import './EventModal.scss';

export { useEventModal } from './useEventModal';
